import * as Preact from "preact"

import UnitSprite from "@frog/source/views/components/UnitSprite.jsx"
import unitJobs from "@frog/source/data/unit-jobs.js"
import Random from "@frog/source/utility/Random.js"

import "@frog/source/views/components/UnitTemplateSprite.less"

export default class UnitTemplateSprite {
    render() {
        if(this.props.unitTemplate.type != undefined) {
            return(
                <div class="PlaceholderSpot"/>
            )
        }
        if(this.props.unitTemplate.randomJobKey != undefined) {
            const jobKeys = []
            this.props.unitTemplate.randomJobKey.split(",").forEach((jobKey) => {
                jobKey = jobKey.trim()
                jobKeys.push(jobKey)
            })
            return(
                <UnitSprite unit={unitJobs[jobKeys[Math.floor(Date.now()/1000) % jobKeys.length]]} abortSquigglevision={true}/>
            )
        } else {
            return(
                <UnitSprite unit={unitJobs[this.props.unitTemplate.jobKey]} abortSquigglevision={true}/>
            )
        }
    }
}
